import React, { useEffect } from "react";
import {
  Form,
  Input,
  Button,
  DatePicker,
  Select,
  Row,
  Col,
  Card,
  Typography,
} from "antd";
import { UserDoctorDto } from "../../models/UserDoctorDto";
import moment from "moment";

const { Option } = Select;
const { Title } = Typography;

interface UserProfileFormProps {
  onFinish: (values: UserDoctorDto) => void;
  initialValues?: UserDoctorDto;
  isCreate?: boolean;
  showRoleSelect?: boolean;
}

const UserProfileForm: React.FC<UserProfileFormProps> = ({
  onFinish,
  initialValues,
  isCreate = false,
  showRoleSelect = false,
}: UserProfileFormProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      const values = {
        ...initialValues,
        birthDate: initialValues.birthDate
          ? moment(initialValues.birthDate)
          : undefined,
        authorities: initialValues.authorities?.map((auth) => auth.name),
      };
      form.setFieldsValue(values);
    }
  }, [initialValues, form]);

  const onFinishInternal = (values: UserDoctorDto) => {
    onFinish(values);
    // mettere logica per il reset form se necessario
    // form.resetFields();
  };

  return (
    <Card style={{ padding: "24px" }}>
      <Title level={2} style={{ marginBottom: "24px" }}>
        Registrazione Medico
      </Title>
      <Form
        form={form}
        name="register"
        onFinish={onFinishInternal}
        layout="vertical"
        scrollToFirstError
      >
        <Row gutter={24}>
          <Col span={24}>
            <Title level={4}>Informazioni Account</Title>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="login"
              label="Nome utente"
              rules={[
                { required: true, message: "Inserisci il tuo nome utente!" },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message:
                    "Il nome utente può contenere solo lettere e numeri!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                { required: true, message: "Inserisci la tua password!" },
              ]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>
          </Col>
          {showRoleSelect && (
            <Col xs={24} sm={12}>
              <Form.Item
                name="authorities"
                label="Ruolo"
                rules={[{ required: true, message: "Seleziona il tuo ruolo!" }]}
              >
                <Select placeholder="Seleziona ruolo">
                  <Option value="ROLE_ROLE_SPECIALIST">Specialista</Option>
                  <Option value="ROLE_ROLE_ASL_DOCTOR">Medico ASL</Option>
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Title level={4} style={{ marginTop: "24px" }}>
              Informazioni Personali
            </Title>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="firstName"
              label="Nome"
              rules={[{ required: true, message: "Inserisci il tuo nome!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="lastName"
              label="Cognome"
              rules={[{ required: true, message: "Inserisci il tuo cognome!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Inserisci un indirizzo email!" },
                {
                  type: "email",
                  message: "Inserisci un indirizzo email valido!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="phone" label="Telefono">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="birthDate" label="Data di Nascita">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Seleziona data"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="gender" label="Genere">
              <Select placeholder="Seleziona genere">
                <Option value="male">Maschio</Option>
                <Option value="female">Femmina</Option>
                <Option value="other">Altro</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Title level={4} style={{ marginTop: "24px" }}>
              Informazioni Professionali
            </Title>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="specialty" label="Specializzazione">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="taxIdCode" label="Codice Fiscale">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Title level={4} style={{ marginTop: "24px" }}>
              Indirizzo
            </Title>
          </Col>
          <Col xs={24}>
            <Form.Item name="street" label="Via">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="city" label="Città">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="province" label="Provincia">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="postalCode" label="CAP">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item style={{ marginTop: "24px" }}>
          <Button type="primary" htmlType="submit" size="large">
            {isCreate ? "Crea utente" : "Registrati"}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default UserProfileForm;
